<template>
  <div>
    <vs-popup :title="$t(popupTitle)" :active.sync="showModal">
      <div class="mb-10" v-if="model.id == null">
        <div>
          <vs-input
            class="inputx mb-4 mt-1"
            v-model="model.name"
            name="CostTitle"
            :label="$t('CostTitle')"
            v-validate="'required'"
          />
          <span class="text-danger text-sm" v-show="errors.has('CostTitle')">{{
            errors.first("CostTitle")
          }}</span>
        </div>
        <div>
          <label class="vs-select--label">{{
              $t("Account")
            }}</label>
          <v-select
              label="name"
              :options="allSubsidaryAccount"
              name="account"
              v-model="model.accountCode"
              @input="onlistOfSubsidaryAccountSelected"
              :clearable="false"
              dir="rtl"
            >
            </v-select>
          <span
            class="text-danger text-sm"
            v-show="errors.has('account')"
            >{{ errors.first("account") }}</span
          >
        </div>
        <div class="mt-2">

          <label class="vs-select--label">{{
              $t("AccountFloating")
            }}</label>
          <v-select
              label="name"
              :options="listOfFloatingAccount"
              name="FloatingAccount"
              v-model="model.lastLevelOfFloatingAccountCode"
              :clearable="false"
              dir="rtl"
            >
            </v-select>
          <span
            class="text-danger text-sm"
            v-show="errors.has('FloatingAccount')"
            >{{ errors.first("FloatingAccount") }}</span
          >
        </div>
        <div class="w-full">
          <div class="mt-5">
            <label class="vs-select--label">{{
              $t("ExpenseAccount")
            }}</label>
            <v-select
              label="name"
              :options="allSubsidaryAccount"
              name="expenseAccountCode"
              v-model="model.expenseAccountCode"
              :clearable="false"
              dir="rtl"
            >
            </v-select>
            <span class="text-danger text-sm" v-show="errors.has('expenseAccountCode')">{{
              errors.first("expenseAccountCode")
            }}</span>
          </div>
          <div class="mt-5">
            <label class="vs-select--label">{{ $t("PrePaymentAccount") }}</label>
            <v-select
              label="name"
              :options="allSubsidaryAccount"
              name="prepaidAccountCode"
              v-model="model.prepaidAccountCode"
              :clearable="false"
              dir="rtl"
            >
            </v-select>
            <span class="text-danger text-sm" v-show="errors.has('prepaidAccountCode')">{{
              errors.first("prepaidAccountCode")
            }}</span>
          </div>
        </div>
        <vs-textarea
          rows="5"
          class="mt-4"
          name="Description"
          :label="$t('Description')"
          v-model="model.description"
        />
      </div>

      <vs-button
        v-if="model.id != null"
        type="filled"
        class="float-right mb-4 mt-12"
        @click.prevent="submitForm"
        >{{ $t("Save") }}</vs-button
      >
      <vs-button
        v-else
        type="filled"
        class="float-right mb-4"
        :class="model.id != null ? 'mt-12' : ''"
        @click.prevent="submitForm"
        :disabled="!model.name"
        >{{ $t("Save") }}</vs-button
      >
    </vs-popup>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { Validator } from "vee-validate";
import vSelect from "@/components/CustomVSelect.vue";
import costCenter from "../../../store/account/costCenter";

const dict = {
  custom: {
    account: {
      required: "لطفا عنوان حساب را وارد نمایید.",
    },
    CostTitle: {
      required: "لطفا عنوان هزینه را وارد نمایید.",
    },
    FloatingAccount: {
      required: "لطفا عنوان حساب شناوری را وارد نمایید.",
    },
    expenseAccountCode: {
      required: "لطفا عنوان حساب هزینه ای را وارد نمایید.",
    },
    prepaidAccountCode: {
      required: "لطفا حساب پیش پرداخت را وارد نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  components: {
    "v-select": vSelect,
  },
  props: {
    show: { default: false },
    model: {
      default: {},
    },
    parentId: 0,
    parentCode: "",

    products: null,
  },
  data() {
    return {
      AccountTitle: "",
      allSubsidaryAccount: [],
      listOfFloatingAccount: [],
      popupTitle: "",
      accountName: "",
      disabled: false,
    };
  },
  computed: {
    showModal: {
      get: function () {
        this.getData();
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },

  methods: {
    ...mapActions({
      createAccount: "costCenter/createCostTitle",
      fetchAllSubsideryAndDetailsAccount:
        "costCenter/fetchAllSubsideryAndDetailsAccount",
      fetchAllFloatingAccountByParent:
        "costCenter/fetchAllFloatingAccountByParent",
    }),
    getData() {
      this.fetchAllSubsideryAndDetailsAccount().then((result) => {
        this.allSubsidaryAccount=[]
        result.forEach((element) => {
          var x = {
            id: element.id,
            name: element.title + ' '+ '(' + element.code + ')',
            code: element.code,
          };
          this.allSubsidaryAccount.push(x);
          // this.allSubsidaryAccount=result;
        });
      });
    },
    onlistOfSubsidaryAccountSelected() {
      this.fetchAllFloatingAccountByParent(this.model.accountCode.id).then((result) => {
        result.forEach((element) => {
          var x = {
            id: element.id,
            name: element.title + ' '+ '(' + element.code + ')',
            code: element.code,
          };
          this.listOfFloatingAccount.push(x);
        });
      });
    },
    submitForm() {
      this.$validator.validateAll().then((result) => {
        this.disabled = true;
        if (result) {
          var payload={
            accountId:this.model.accountCode.id,
            lastLevelOfFloatingAccountId:this.model.lastLevelOfFloatingAccountCode.id,
            expenseAccountId:this.model.expenseAccountCode?this.model.expenseAccountCode.id:null,
            prepaidAccountId:this.model.prepaidAccountCode?this.model.prepaidAccountCode.id:null,
            description:this.model.description,
            name:this.model.name,
          }
          this.model.parentAccountId = this.parentId;
          this.createAccount(payload).then(() => {
            this.$emit("finish");
            this.model = {};
            this.$validator.reset();
            this.disabled = false;
          });
        } else {
          // form have errors
        }
      });
    },
  },
  watch: {
    show() {
      if (this.show == true) {
        this.disabled = false;

        if (this.model.id) this.popupTitle = "EditCostTitle";
        else this.popupTitle = "CreateCostTitle";
      }
      this.$validator.reset();
    },
  },
};
</script>
<style></style>
